import {
  FlatList,
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TextInput,
  TouchableOpacity,
  Modal,
  TouchableWithoutFeedback,
  Pressable,
} from "react-native";
import React, { useState } from "react";
import AppImages from "../../Constants/AppImages";
import AppColors from "../../Constants/AppColors";
import { Block, Driver1 } from "../../Constants/Data";
import AppFonts from "../../Constants/AppFonts";
// import { useTranslation } from "react-i18next";
const DeliveryHistory = ({ navigation }) => {
  const [DotModal, setDotModal] = useState(false);
  const [select, setSelected] = useState(0);
  const [Modalvisible1, setModalvisible1] = useState(false);

  const [Modalvisible2, setModalvisible2] = useState(false);

  const [Modalvisible3, setModalvisible3] = useState(false);
  const handlePress = () => {
    setSelected(!select);
  };
  const [selectedButton, setSelectedButton] = useState(null);

  const handleBoxPressbtn = (item) => {
    setSelectedButton(item);
  };
  const [activeIndex, setActiveIndex] = useState(1);
  const handleTextPress = (index) => {
    setActiveIndex(index);
  };
  //---------Search Text Input---------//
  const Driver1 = [
    {
      id: 1,
      img1: AppImages.Boypicture,
      H1: "Driver Name",
      H2: "Mark S Woods",
      img2: AppImages.Threedots,
      H3: "Contact No",
      H4: "9999999999",
      H5: "Email",
      H6: "markwoods@gmail.com",
      H7: "Vehicle No.",
      H8: "MH-12-2023",
      H9: "Vehicle Assignment.",
      H10: "Toyota Innova",
      H11: "Address",
      H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
    },
    {
      id: 2,
      img1: AppImages.Boypicture,
      H1: "Driver Name",
      H2: "Mark S Woods",
      img2: AppImages.Threedots,
      H3: "Contact No",
      H4: "9999999999",
      H5: "Email",
      H6: "markwoods@gmail.com",
      H7: "Vehicle No.",
      H8: "MH-12-2023",
      H9: "Vehicle Assignment.",
      H10: "Toyota Innova",
      H11: "Address",
      H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
      img3: AppImages.Greyclose,
    },
    {
      id: 3,
      img1: AppImages.Boypicture,
      H1: "Driver Name",
      H2: "Mark S Woods",
      img2: AppImages.Threedots,
      H3: "Contact No",
      H4: "9999999999",
      H5: "Email",
      H6: "markwoods@gmail.com",
      H7: "Vehicle No.",
      H8: "MH-12-2023",
      H9: "Vehicle Assignment.",
      H10: "Toyota Innova",
      H11: "Address",
      H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
      img3: AppImages.Greyclose,
    },
    {
      id: 4,
      img1: AppImages.Boypicture,
      H1: "Driver Name",
      H2: "Mark S Woods",
      img2: AppImages.Threedots,
      H3: "Contact No",
      H4: "9999999999",
      H5: "Email",
      H6: "markwoods@gmail.com",
      H7: "Vehicle No.",
      H8: "MH-12-2023",
      H9: "Vehicle Assignment.",
      H10: "Toyota Innova",
      H11: "Address",
      H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
    },
    {
      id: 5,
      img1: AppImages.Boypicture,
      H1: "Driver Name",
      H2: "Mark S Woods",
      img2: AppImages.Threedots,
      H3: "Contact No",
      H4: "9999999999",
      H5: "Email",
      H6: "markwoods@gmail.com",
      H7: "Vehicle No.",
      H8: "MH-12-2023",
      H9: "Vehicle Assignment.",
      H10: "Toyota Innova",
      H11: "Address",
      H12: "Vishrantwadi, Kalas Road, Pune- 411030.",
    },
  ];
  const [selectedItem, setSelectedItem] = useState(null);
  const [data, setData] = useState(Driver1);
  const [searchText, setSearchText] = useState(""); // State for search input
  const handleSearch = (text) => {
    setSearchText(text);
    // Implement search logic here to filter the data based on the entered text
    const filteredData = Driver1.filter((item) =>
      item.H2.toLowerCase().includes(text.toLowerCase())
    );
    setData(filteredData);
  };
  //-------Del FlatList ---------//
  const handleThreeDotPress = (item) => {
    setSelectedItem(item);
    setDotModal(true);
  };
  const handleDeleteConfirmation = () => {
    setDotModal(false);
    setModalvisible3(true);
  };

  const handleDelete = (itemToDelete) => {
    const updatedData = data.filter((item) => item !== itemToDelete);
    setData(updatedData);
    setModalvisible3(false);
    setSelectedItem(null);
  };
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };

  return (
    <SafeAreaView style={{ flex: 1, backgroundColor: AppColors.white }}>
      <View style={{ flex: 1, marginHorizontal: 20 }}>
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: 15,
          }}
        >
          <View
            style={{
              width: "90%",
              height: 40,
              borderColor: AppColors.grey,
              borderWidth: 1,
              backgroundColor: AppColors.white,
              backgroundColor: AppColors.white,
              marginBottom: 15,
              borderRadius: 10,
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <TextInput
              placeholder={t("common:translation.Search Delivery Person")}
              placeholderTextColor={AppColors.grey}
              style={{ left: 10, width: "80%", color: AppColors.brown2 }}
              editable={true}
              value={searchText} // Bind search input value to state
              onChangeText={handleSearch}
            />
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <Image
                source={AppImages.search}
                style={{ width: 18, height: 18, marginRight: 20 }}
              />
            </View>
          </View>
          <Image
            source={AppImages.Shareit}
            style={{ width: 24, height: 21, marginLeft: 10, marginBottom: 10 }}
          />
        </View>
        <FlatList
          showsVerticalScrollIndicator={false}
          data={data}
          ListFooterComponent={() => <View style={{ marginBottom: 20 }}></View>}
          renderItem={({ item }) => (
            <TouchableOpacity
              onPress={() => navigation.navigate("DeliverypersonView")}
              style={{
                width: "100%",
                backgroundColor: AppColors.sandal,
                marginBottom: 20,
                borderRadius: 10,
              }}
            >
              <View
                style={{
                  marginTop: 10,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={{ flexDirection: "row" }}>
                  <Image
                    source={item.img1}
                    style={{ height: 48, width: 48, marginLeft: 20 }}
                  />
                  <View style={{ marginLeft: 35, flexDirection: "column" }}>
                    <Text
                      style={{
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 12,
                        fontWeight: "400",
                        color: AppColors.brown1,
                        opacity: 0.6,
                      }}
                    >
                      {t("common:translation.Driver Name")}
                    </Text>
                    <Text
                      style={{
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,

                        color: AppColors.brown1,
                      }}
                    >
                      {item.H2}
                    </Text>
                  </View>
                </View>
                <TouchableOpacity
                  onPress={() => handleThreeDotPress(item)}
                  style={{
                    width: 25,
                    height: 25,
                    marginTop: 10,
                    alignItems: "flex-end",
                  }}
                >
                  <Image
                    source={item.img2}
                    resizeMode="contain"
                    style={{
                      width: 3,
                      height: 17,
                      marginRight: 20,

                      alignItems: "center",
                    }}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width: "100%",

                  borderTopColor: AppColors.brown,
                  borderTopWidth: 0.7,
                  opacity: 0.099,
                  marginTop: 10,
                  marginBottom: 10,
                }}
              ></View>

              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",

                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    marginBottom: 5,
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 12,
                    color: AppColors.brown1,
                    opacity: 0.6,
                    width: "50%",
                  }}
                >
                  {t("common:translation.Contact No")}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 12,
                    color: AppColors.brown1,
                    opacity: 0.6,
                    width: "50%",
                  }}
                >
                  {t("common:translation.Email")}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",

                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,

                    fontSize: 14,
                    color: AppColors.brown1,
                    width: "50%",
                  }}
                >
                  {item.H4}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,

                    fontSize: 14,
                    color: AppColors.brown1,
                    width: "50%",
                  }}
                >
                  {item.H6}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",

                  marginTop: 5,
                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 12,
                    color: AppColors.brown1,
                    opacity: 0.6,
                    width: "50%",
                  }}
                >
                  {t("common:translation.Vehicle No")}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 12,
                    color: AppColors.brown1,
                    opacity: 0.6,
                    width: "50%",
                  }}
                >
                  {t("common:translation.Vehicle Assignment")}
                </Text>
              </View>
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",

                  marginHorizontal: 20,
                }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,
                    width: "50%",
                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  {item.H8}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,
                    width: "50%",

                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  {item.H10}
                </Text>
              </View>
              <View
                style={{ width: "80%", marginHorizontal: 20, marginBottom: 10 }}
              >
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassMedium,
                    fontWeight: "400",
                    fontSize: 12,
                    color: AppColors.brown1,
                    opacity: 0.6,
                    width: "50%",
                    marginTop: 10,
                  }}
                >
                  {t("common:translation.Address")}
                </Text>
                <Text
                  style={{
                    fontFamily: AppFonts.OverpassSemiBold,

                    fontSize: 14,
                    color: AppColors.brown1,
                  }}
                >
                  {item.H12}
                </Text>
              </View>
            </TouchableOpacity>
          )}
        />
        <Modal
          animationType="slide"
          visible={DotModal}
          onRequestClose={() => {
            setDotModal(false);
          }}
          transparent={true}
        >
          <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
            <View
              style={{ backgroundColor: AppColors.ModalColor, flex: 1 }}
            ></View>
          </TouchableWithoutFeedback>
          <View
            style={{
              width: "100%",
              backgroundColor: "white",

              borderTopRightRadius: 16,
              borderTopLeftRadius: 16,
              position: "absolute",
              bottom: 0,
              padding: 20,
            }}
          >
            <TouchableOpacity
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <Image
                source={AppImages.LineBar}
                style={{ width: "15%", height: 2 }}
              />
            </TouchableOpacity>

            <TouchableWithoutFeedback
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                setDotModal(false),
                navigation.navigate("DeliverypersonView"),
                handleTextPress(1),
              ]}
            >
              <View
                style={{
                  marginLeft: 10,
                }}
              >
                <Text
                  style={[styles.text, activeIndex === 1 && styles.activeText]}
                >
                  {t("common:translation.View")}
                </Text>
              </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                setDotModal(false),
                navigation.navigate("EditDeliveryperson"),
                handleTextPress(2),
              ]}
            >
              <View
                style={{
                  marginLeft: 10,
                }}
              >
                <Text
                  style={[styles.text, activeIndex === 2 && styles.activeText]}
                >
                  {t("common:translation.Edit")}
                </Text>
              </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                setDotModal(false),
                navigation.navigate("ChangeDeliveryPassword"),
                handleTextPress(3),
              ]}
            >
              <View
                style={{
                  marginLeft: 10,
                }}
              >
                <Text
                  style={[styles.text, activeIndex === 3 && styles.activeText]}
                >
                  {t("common:translation.Change Password")}
                </Text>
              </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                setDotModal(false),
                setModalvisible1(true),
                handleTextPress(4),
              ]}
            >
              <View
                style={{
                  marginLeft: 10,
                }}
              >
                <Text
                  style={[styles.text, activeIndex === 4 && styles.activeText]}
                >
                  {t("common:translation.Block")}
                </Text>
              </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [
                setDotModal(false),
                setModalvisible2(true),
                handleTextPress(5),
              ]}
            >
              <View
                style={{
                  marginLeft: 10,
                }}
              >
                <Text
                  style={[styles.text, activeIndex === 5 && styles.activeText]}
                >
                  {t("common:translation.Resign")}
                </Text>
              </View>
            </TouchableWithoutFeedback>
            <TouchableWithoutFeedback
              style={{
                marginTop: 20,
                flexDirection: "row",
              }}
              onPress={() => [handleDeleteConfirmation(), handleTextPress(6)]}
            >
              <View
                style={{
                  marginLeft: 10,
                }}
              >
                <Text
                  style={[styles.text, activeIndex === 6 && styles.activeText]}
                >
                  {t("common:translation.Delete")}
                </Text>
              </View>
            </TouchableWithoutFeedback>
          </View>
        </Modal>
        <Modal
          animationType="slide"
          transparent={true}
          visible={Modalvisible1}
          onRequestClose={() => {
            setModalvisible1(!Modalvisible1);
          }}
        >
          <Pressable
            onPress={() => setModalvisible1(true)}
            style={{
              flex: 1,
              backgroundColor: AppColors.ModalColor,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                backgroundColor: AppColors.white,
                width: "90%",
                padding: 20,
                borderRadius: 15,
                margin: 20,
              }}
            >
              <View style={{}}>
                <TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 20,
                      }}
                    >
                      Block
                    </Text>
                    <TouchableOpacity onPress={() => setModalvisible1(false)}>
                      <Image
                        source={AppImages.Delpic}
                        style={{ height: 14, width: 13 }}
                      />
                    </TouchableOpacity>
                  </View>
                </TouchableOpacity>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>

                <Text
                  style={{
                    color: AppColors.brown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 14,
                    width: "100%",
                  }}
                >
                  Are you sure you want to Block ?
                </Text>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setModalvisible1(false)}
                    style={{
                      width: "30%",
                      height: 35,
                      borderColor: AppColors.brown,
                      borderWidth: 1,
                      borderRadius: 10,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      Cancel
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setModalvisible1(false)}
                    style={{
                      width: "30%",
                      height: 35,
                      backgroundColor: AppColors.brown,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 10,
                      marginLeft: 20,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.white,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      yes
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Pressable>
        </Modal>
        <Modal
          animationType="slide"
          transparent={true}
          visible={Modalvisible2}
          onRequestClose={() => {
            setModalvisible2(!Modalvisible2);
          }}
        >
          <Pressable
            onPress={() => setModalvisible2(true)}
            style={{
              flex: 1,
              backgroundColor: AppColors.ModalColor,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                backgroundColor: AppColors.white,
                width: "90%",
                padding: 20,
                borderRadius: 15,
                margin: 20,
              }}
            >
              <View style={{}}>
                <TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 20,
                      }}
                    >
                      Resign / Retire
                    </Text>
                    <TouchableOpacity onPress={() => setModalvisible2(false)}>
                      <Image
                        source={AppImages.Delpic}
                        style={{ height: 14, width: 13 }}
                      />
                    </TouchableOpacity>
                  </View>
                </TouchableOpacity>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>

                <Text
                  style={{
                    color: AppColors.brown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 14,
                    width: "100%",
                  }}
                >
                  Are you sure you want to Resign / Retire ?
                </Text>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setModalvisible2(false)}
                    style={{
                      width: "30%",
                      height: 35,
                      borderColor: AppColors.brown,
                      borderWidth: 1,
                      borderRadius: 10,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      Cancel
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => setModalvisible2(false)}
                    style={{
                      width: "30%",
                      height: 35,
                      backgroundColor: AppColors.brown,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 10,
                      marginLeft: 20,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.white,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      yes
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Pressable>
        </Modal>
        <Modal
          animationType="slide"
          transparent={true}
          visible={Modalvisible3}
          onRequestClose={() => {
            setModalvisible3(!Modalvisible3);
          }}
        >
          <Pressable
            onPress={() => setModalvisible3(true)}
            style={{
              flex: 1,
              backgroundColor: AppColors.ModalColor,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <View
              style={{
                backgroundColor: AppColors.white,
                width: "90%",
                padding: 20,
                borderRadius: 15,
                margin: 20,
              }}
            >
              <View style={{}}>
                <TouchableOpacity>
                  <View
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown1,
                        fontFamily: AppFonts.OverpassRegular,
                        fontSize: 20,
                      }}
                    >
                      Delete
                    </Text>
                    <TouchableOpacity onPress={() => setModalvisible3(false)}>
                      <Image
                        source={AppImages.Delpic}
                        style={{ height: 14, width: 13 }}
                      />
                    </TouchableOpacity>
                  </View>
                </TouchableOpacity>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>

                <Text
                  style={{
                    color: AppColors.brown,
                    fontFamily: AppFonts.OverpassRegular,
                    fontSize: 14,
                    width: "100%",
                  }}
                >
                  Are you sure you want to Delete ?
                </Text>
                <View
                  style={{
                    borderWidth: 0.4,
                    borderColor: AppColors.brown1,
                    opacity: 0.099,
                    marginTop: 10,
                    marginBottom: 10,
                    alignItems: "center",
                  }}
                ></View>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    onPress={() => setModalvisible3(false)}
                    style={{
                      width: "30%",
                      height: 35,
                      borderColor: AppColors.brown,
                      borderWidth: 1,
                      borderRadius: 10,
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.brown,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      Cancel
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => handleDelete(selectedItem)}
                    style={{
                      width: "30%",
                      height: 35,
                      backgroundColor: AppColors.brown,
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 10,
                      marginLeft: 20,
                    }}
                  >
                    <Text
                      style={{
                        color: AppColors.white,
                        fontFamily: AppFonts.OverpassSemiBold,
                        fontSize: 14,
                      }}
                    >
                      yes
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </Pressable>
        </Modal>
      </View>
    </SafeAreaView>
  );
};

export default DeliveryHistory;

const styles = StyleSheet.create({
  hox: {
    flexDirection: "row",
    justifyContent: "flex-end",
    marginVertical: 20,
  },
  presss: {
    width: "40%",
    // marginHorizontal: 20,
  },
  //-------cancel  btn---//
  sty: {
    flexDirection: "row",
    marginVertical: 10,
  },
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    padding: 5,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    // color: AppColors.white,
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  lins: {
    borderTopWidth: 2,
    width: "100%",
    // right: 20,
    borderTopColor: AppColors.sandal,
    marginTop: 20,
  },
  TExtinputView: {
    flexDirection: "row",

    justifyContent: "space-between",

    alignItems: "center",

    marginTop: 25,

    width: "100%",

    // height: height * 0.04,
    marginBottom: 20,
  },

  TExtinput: {
    fontSize: 12,
    backgroundColor: AppColors.white,

    alignItems: "center",

    fontFamily: AppFonts.OverpassMedium,

    width: "80%",
    paddingLeft: 8,
    borderRadius: 10,

    borderColor: AppColors.sandal,

    // height: height * 0.06,
    paddingVertical: 10,

    borderWidth: 1,

    flexDirection: "row",

    borderRadius: 8,

    justifyContent: "space-between",

    shadowColor: "#000001A",

    shadowOffset: { width: 1, height: 2 },

    shadowOpacity: 0.1,

    shadowRadius: 1, // elevation: 6,
  },

  ExImport: { flexDirection: "row", marginHorizontal: 5 },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.brown2,
    marginTop: 20,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 20,
    fontSize: 14,
    color: AppColors.brown1,
  },
});
